@if (content && hasContent) {
  <div fxLayout="column" fxLayoutGap="20px">
    <h2 class="text-center">{{ label }}</h2>
    @if (content.studyProgram || content.age) {
      <ag-clcd-study-programs
        [studyProgram]="content.studyProgram"
        [age]="content.age"
      ></ag-clcd-study-programs>
    }
    @if (content.awards) {
      <ag-clcd-awards [awards]="content.awards"></ag-clcd-awards>
    }
    @if (content.reviews) {
      <ag-clcd-reviews [reviews]="content.reviews"></ag-clcd-reviews>
    }
    @if (carouselItems.length > 0) {
      <ag-clcd-books-like-this [carouselItems]="carouselItems"></ag-clcd-books-like-this>
    }
  </div>
}
